import { closest } from './_closest';

export function hover() {
  const hov = document.querySelectorAll('a, button, .hov');
  if(hasTouchScreen()) {
    for (let i = 0; i < hov.length; i++) {
      const el = hov[i];
      const parent = closest(el, 'js-hover-parent-touch');
      el.addEventListener('touchstart', function(e) {
        this.classList.add('hover-touch');
        if(parent) {
          parent.classList.add('hover-parent-touch');
        }
      });
      el.addEventListener('touchend', function(e) {
        this.classList.remove('hover-touch');
        if(parent) {
          parent.classList.remove('hover-parent-touch');
        }
      });
    };
  } else {
    for (let i = 0; i < hov.length; i++) {
      const el = hov[i];
      const parent = closest(el, 'js-hover-parent');
      el.addEventListener('mouseenter', function(e) {
        this.classList.add('hover');
        if(parent) {
          parent.classList.add('hover-parent');
        }
      });
      el.addEventListener('mouseleave', function(e) {
        this.classList.remove('hover');
        if(parent) {
          parent.classList.remove('hover-parent');
        }
      });
    };
  }
}

export function hoverDynamic(el) {
  if(el) {
    if(hasTouchScreen()) {
      el.addEventListener('touchstart', function(e) {
        this.classList.add('hover-touch');
        const parent = closest(el, 'js-hover-parent-touch');
        if(parent) {
          parent.classList.add('hover-parent-touch');
        }
      });
      el.addEventListener('touchend', function(e) {
        this.classList.remove('hover-touch');
        const parent = closest(el, 'js-hover-parent-touch');
        if(parent) {
          parent.classList.remove('hover-parent-touch');
        }
      });
    } else {
      el.addEventListener('mouseenter', function(e) {
        this.classList.add('hover');
        const parent = closest(el, 'js-hover-parent');
        if(parent) {
          parent.classList.add('hover-parent');
        }
      });
      el.addEventListener('mouseleave', function(e) {
        this.classList.remove('hover');
        const parent = closest(el, 'js-hover-parent');
        if(parent) {
          parent.classList.remove('hover-parent');
        }
      });
    }
  }
}